import { useRef } from 'react';
import { getVideoUrlIframe } from '../../../Utils/helper';
import { IframeVideo } from '../../GrowthTrackerPage/Inthisweek/styled';
import { VideoStyle } from './styled';

export function YotubrVideoFrame(props) {
  let { src } = props;
  const player = useRef(null);

  const youtubeApiHandler = (url) => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.onload = onYouTubeIframeAPIReady;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function onYouTubeIframeAPIReady() {
      window.YT.ready(() => {
        player.current = new YT.Player('yt-player', {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
      });
    }

    function onPlayerReady(event) {
      event.target.playVideo();
    }

    function onPlayerStateChange(event) {
      if (event.data == 0) {
        typeof player.current.stopVideo() === 'function' &&
          player.current.stopVideo(); // for not showing related and Suggested vedios after vedio ends..
      }
      // -1 – unstarted
      // 0 – ended
      // 1 – playing
      // 2 – paused
      // 3 – buffering
      // 5 – video cued
    }
  };

  return (
    <VideoStyle>
      <IframeVideo
        onLoad={youtubeApiHandler}
        id={'yt-player'}
        storeVideo
        type="text/html"
        src={getVideoUrlIframe(src, 1, 1)}
        frameBorder="0"
        allowFullScreen
        allow={'autoplay'}
      ></IframeVideo>
    </VideoStyle>
  );
}
